import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFDeactivate = {};

export const IBF_DEACTIVATE = {
  value: 0x0001,
  name: "IBF_DEACTIVATE",
  size: 0,
  parse: (): IBFDeactivate => {
    return {};
  },
} satisfies IBFHistoryRecordDefinition<IBFDeactivate>;
